import React from 'react'
import { useCrossLocationFulfilmentGate } from '../../OutletSelect'
import { LineItemFulfilmentDecisionView as LineItemFulfilmentDecisionViewUnified } from './LineItemFulfilmentDecisionView'
import { LineItemFulfilmentDecisionViewLegacy } from './LineItemFulfilmentDecisionViewLegacy'
import type { LineItemFulfilmentDecisionViewProps } from './useLineItemFulfilmentDecisionViewModel'

export type { LineItemFulfilmentDecisionViewProps } from './useLineItemFulfilmentDecisionViewModel'

export const LineItemFulfilmentDecisionView: React.FC<LineItemFulfilmentDecisionViewProps> = props => {
  const { canUseCrossLocationFulfilment } = useCrossLocationFulfilmentGate()

  return canUseCrossLocationFulfilment ? (
    <LineItemFulfilmentDecisionViewUnified {...props} />
  ) : (
    <LineItemFulfilmentDecisionViewLegacy {...props} />
  )
}
